module.exports = __webpack_public_path__ + "static/media/JA.1c43d060.png";